'use strict';exports.__esModule = true;exports.getCitiesValues = exports.getPropertyTypesValues = undefined;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var cities = [
{ name: 'tel-aviv-yafo', localisation: { en: 'Tel Aviv-Yafo', he: 'תל אביב יפו', ru: 'Тель Авив Яффо', fr: 'Tel Aviv-Yafo' } },
{ name: 'rishon-letsiyon', localisation: { en: 'Rishon LeTsiyon', he: 'ראשון לציון', ru: 'Ришон ле-Цион', fr: 'Rishon LeTsiyon' } },
{ name: 'holon', localisation: { en: 'Holon', he: 'חולון', ru: 'Холон', fr: 'Holon' } },
{ name: 'ashdod', localisation: { en: 'Ashdod', he: 'אשדוד', ru: 'Ашдод', fr: 'Ashdod' } },
{ name: 'bat-yam', localisation: { en: 'Bat Yam', he: 'בת ים', ru: 'Бат Ям', fr: 'Bat Yam' } },
{ name: 'givatayim', localisation: { en: 'Givatayim', he: 'גבעתיים', ru: 'Гиватаим', fr: 'Givatayim' } }];


var propTypes = ['apartment', 'cottage', 'penthouse', 'garden_apartment'];

var getPropertyTypesValues = exports.getPropertyTypesValues = function getPropertyTypesValues(translate) {return propTypes.map(function (type) {return {
      value: type,
      label: translate('propertyTypes', type) };});};


var getCitiesValues = exports.getCitiesValues = function getCitiesValues(locale) {return cities.map(function (city) {return {
      value: (0, _get2.default)(city, 'localisation.en'),
      label: (0, _get2.default)(city, 'localisation.' + locale) };});};


//////////////////
// WEBPACK FOOTER
// ./src/containers/HomePagePropertiesContainer/helpers.js
// module id = 2941
// module chunks = 0